module.exports = __webpack_public_path__ + "5cc34974b8880807f82acd3008f2f1f3.svg";